export default {
      id: "analysis-usage",
      viewBox: "0 0 16.362 16.362",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#analysis",
      toString: function () {
        return this.url;
      }
    }